module.exports = __webpack_public_path__ + "static/media/character-single-bg.0c85682b.svg";